import styled, { css } from 'styled-components';

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  max-width: 95vw;
  overflow-y: auto;
  gap: 8px;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    -webkit-appearance: none;
    width: 0 !important;
    height: 0 !important;
  }
`;

interface IFilterBlock {
  $active?: boolean;
}

const FilterBlockActive = css`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 4px 8px rgba(104, 113, 123, 0.07);
`;

export const FilterBlock = styled.div<IFilterBlock>`
  display: flex;
  height: 36px;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  min-width: 40px;
  justify-content: center;
  align-items: center;
  flex: 1 0 auto;
  cursor: pointer;

  ${({ $active }) => $active
    ? FilterBlockActive
    : null
}
`;
